module.exports = __webpack_public_path__ + "static/img/icon_info_06.1b63b438.png";